export enum WorkType {
  None = "",
  Company = "Working for Company",
  CompanyPartTime = "Working for Company part-time",
  Faction = "Working for Faction",
  CreateProgram = "Working on Create a Program",
  StudyClass = "Studying or Taking a class at university",
  Crime = "Committing a crime",
  GraftAugmentation = "Grafting an Augmentation",
}

export enum PlayerFactionWorkType {
  None = "",
  Hacking = "Faction Hacking Work",
  Field = "Faction Field Work",
  Security = "Faction Security Work",
}

export enum ClassType {
  None = "",
  StudyComputerScience = "studying Computer Science",
  DataStructures = "taking a Data Structures course",
  Networks = "taking a Networks course",
  Algorithms = "taking an Algorithms course",

  Management = "taking a Management course",
  Leadership = "taking a Leadership course",

  GymStrength = "training your strength at a gym",
  GymDefense = "training your defense at a gym",
  GymDexterity = "training your dexterity at a gym",
  GymAgility = "training your agility at a gym",
}

export enum CrimeType {
  None = "",
  Shoplift = "shoplift",
  RobStore = "rob a store",
  Mug = "mug someone",
  Larceny = "commit larceny",
  Drugs = "deal drugs",
  BondForgery = "forge corporate bonds",
  TraffickArms = "traffick illegal arms",
  Homicide = "commit homicide",
  GrandTheftAuto = "commit grand theft auto",
  Kidnap = "kidnap someone for ransom",
  Assassination = "assassinate a high-profile target",
  Heist = "pull off the ultimate heist",
}
